import { UploadsHistoryTranslation } from './uploadsHistory.translation.pl.ts';

export const uploadsHistoryTranslation: UploadsHistoryTranslation = {
  actions: {
    continue: 'Continue',
    resolveErrors: 'Resolve Errors',
    viewResolvedErrors: 'View resolved errors',
  },
  columns: {
    actions: 'Actions',
    createdAt: 'Created At',
    creator: 'Creator',
    fileName: 'File Name',
    progress: 'Progress',
    status: 'Status',
    type: 'Type',
  },
  filters: {
    status: 'Status',
    uploadType: 'Upload Type',
  },
  status: {
    AWAITING_VALIDATION_RESOLUTION: 'Awaiting Resolution',
    ERROR: 'Error',
    FINISHED: 'Finished',
    IN_PROGRESS: 'In Progress',
    NOT_STARTED: 'Not Started',
    PROCESSING_CHUNKS: 'Processing Chunks',
    READING_DOCUMENT: 'Reading Document',
    VALIDATION_FAILED: 'Validation Failed',
  },
  title: 'Uploads History',
  types: {
    CHAT_DOCUMENT: 'Chat Document',
    COMPANY_POSITIONS: 'Company Positions',
    DEVELOPMENT_ACTIVITIES: 'Development Activities',
    DOCUMENT: 'Document',
    EDUAKCJA: 'Education',
    EMPLOYEE_DATA: 'Employee Data',
    EMPLOYEES: 'Employees',
    EMPLOYEES_EMPLOYMENT_HISTORY: 'Employment History',
    EMPLOYEES_ENABLE_CHANGE: 'Activity Change',
    MDR: 'MDR',
    SUCCESSION_DATA: 'Succession Data',
    SYSTEM_USERS: 'System Users',
  },
};
